import React from "react";
import "./Spinner.css";

export default function Spinner({
    text = "در حال بارگذاری..."
}) {
    return ( <
        div className = "loading-wrapper" >
        <
        div className = "spinner" > < /div> {
            text && < p > {
                    text
                } < /p>} <
                /div>
        );
    }